






























































import { Component, Vue } from "vue-property-decorator";
import AuditTabGroupOfInternalProject from "@/views/myAudit/internalProject.vue";
import AuditTabGroupOfFinance from "@/views/myAudit/finance.vue";
import AuditTabGroupOfExternalProject from "@/views/myAudit/externalProject.vue";
import AuditTabOfOrganizationUnit from "@/views/myAudit/tabs/tabOrganizationUnit.vue";
import AuditTabGroupOfNormal from "@/views/myAudit/normal.vue";
import AuditCount from "@/views/myAudit/components/AuditCount.vue";
import AuditTabFund from "@/views/myAudit/fund.vue";
import AuditTabFundProject from "@/views/myAudit/fundProject.vue";
import AuditTabTask from "@/views/myAudit/task.vue";
import AuditTabVolunteer from "@/views/myAudit/volunteer.vue";
// import AuditTabActivity from "@/views/myAudit/activity.vue";

@Component({
  name: "MyAudit",
  components: {
    AuditTabGroupOfNormal,
    AuditTabOfOrganizationUnit,
    AuditTabGroupOfExternalProject,
    AuditTabGroupOfFinance,
    AuditTabGroupOfInternalProject,
    AuditCount,
    AuditTabFund,
    AuditTabFundProject,
    AuditTabTask,
    AuditTabVolunteer,
    // AuditTabActivity,
  },
})
export default class MyAudit extends Vue {
  countDic: any = {
    normal: 0,
    "internal-project": 0,
    "external-project": 0,
    finance: 0,
    fund: 0,
    fundProject: 0,
    task: 0,
    volunteer: 0
  };

  handleCountChange(target: any) {
    this.countDic[target[0]] = target[1];
  }
}
